module.exports = __webpack_public_path__ + "media/images/it/favicon-c6d923a4f8d9ffb4318aff4cc6059d92.png";